import { CreateDealAssociation, CreateDealAssociationVariables } from './__generated__/CreateDealAssociation'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation CreateDealAssociation($input: DealAssociationInputV2!) {
    createDealAssociation: createDealAssociationV2(input: $input) {
      ... on DealAssociationV2 {
        id
        emailAddress
        dealId
      }
      ... on DealAssociationErrorV2 {
        type
        error
      }
    }
  }
`

export const useCreateDealAssociation = () =>
  useMutation<CreateDealAssociation, CreateDealAssociationVariables>(MUTATION)
